var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),_c('main',{staticClass:"bg-greyblue"},[_c('BarriersPreformance'),_c('peer-table',{staticClass:"mb-8"}),_c('trends'),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }